<template>
  <div class="h-100">
    <div class="loader-cont" v-dxloader="isLoader"></div>
    <div class="row h-100" v-show="!isLoader">
      <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
      <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
        <!-- Search for small screen-->
        <div class="container">
          <div class="row">
            <div class="col s10 m6 l6 alignLeft">
              <h5 class="card-title alignLeft white-text">Issue Tickets</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="col s12 p-0" style="height:calc(100% - 45px)">
        <div class="container p-0 h-100">
          <div class="section p-0 h-100">
            <div class="row m-0 h-100">
              <div class="col s12 m12 l12 p-0 h-100">
                <div id="responsive-table" class="card card card-default scrollspy mb-0 h-100">
                  <div class="card-content h-100" style="overflow:auto">
                    <div class="row filter-cls">
                      <div class="search-input col s4 m5 l5">
                        <div class="sidebar-search animate fadeUp">
                          <div class="search-area">
                            <i class="material-icons mr-2 search-icon">search</i>
                            <i
                              class="material-icons mr-2 close-icon"
                              v-show="filters.search"
                              @click="filters.search=''"
                            >close</i>
                            <input
                              type="text"
                              v-model="filters.search"
                              placeholder="Search Issues"
                              class="app-filter"
                              id="chat_filter"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col s4 m2 l2">
                        <div class="input-field">
                          <select id="priority" name="priority" v-model="filters.priority">
                            <option selected value>Filter by priority</option>
                            <option
                              v-for="data1 in filterData.priority"
                              :key="data1"
                              :value="data1"
                            >{{data1}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col s4 m3 l3">
                        <div class="input-field">
                          <select
                            id="classification"
                            name="classification"
                            v-model="filters.classification"
                          >
                            <option selected value>Filter by classification</option>
                            <option
                              v-for="data2 in filterData.classification"
                              :key="data2"
                              :value="data2"
                            >{{data2}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col s4 m2 l2">
                        <div class="input-field">
                          <select id="status" name="status" v-model="filters.status">
                            <option selected value>Filter by status</option>
                            <option
                              v-for="data3 in filterData.status"
                              :key="data3"
                              :value="data3"
                            >{{data3}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="isAdmin">
                      <div class="col s12">
                        <ul class="tabs">
                          <li class="tab">
                            <a :class="{'active' : currTab==1}">My Issues</a>
                          </li>
                          <li class="tab">
                            <a :class="{'active' : currTab==2}">Issues</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div id="issues" class="row issue-block" style="height:calc(100% - 120px); overflow-y: auto">
                      <div
                        :class="{'inner-block' : finalIssueList.length>0}"
                        class="col s12 l12 m12"
                      >
                        <div
                          class="card-view row"
                          v-for="(issue,index) in finalIssueList"
                          :key="issue.issue_no"
                        >
                          <div class="col s6 m6 l6 pl-0">
                            <div
                              class="card-view-content pointer"
                              @click="selectTicket(issue,$event)"
                            >
                              <div class="indicator"></div>
                              <div class="text-content">
                                <div class="title-cd">
                                  <span>#{{issue.issue_no}}</span>
                                </div>
                                <div class="title-cd">
                                  {{issue.title}}
                                  <a
                                    class="pointer booking"
                                    @click="$router.push({path: 'booking-detail/' + issue.booking})"
                                    v-if="issue.booking"
                                  >({{issue.booking}})</a>
                                </div>
                                <div class="inn-cont">
                                  <div
                                    class="owner"
                                  >{{issue.issue_owner ? issue.issue_owner.first_name : "-"}}</div>
                                  <div class="created_at">{{issue.created | relativeTime}}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col s3 m3 l3">
                            <div class="select-cards select-cls issue">
                              <div class="icon-clas"></div>
                              <select
                                @change="changePriority(issue)"
                                :name="'issue_priority' + issue"
                                v-model="issue.issue_priority"
                              >
                                <option
                                  v-for="filter in filterData.priority"
                                  :key="filter"
                                  :value="filter"
                                >{{filter}}</option>
                              </select>
                            </div>
                            <div class="select-cards select-cls issue classi">
                              <div class="select-cls issue classi">
                                <div class="icon-clas q-cls"></div>
                                <select
                                  @change="changeClassification(issue)"
                                  :name="'classification' + issue"
                                  v-model="issue.classification"
                                >
                                  <option
                                    v-for="classi in filterData.classification"
                                    :key="classi"
                                    :value="classi"
                                  >{{classi}}</option>
                                </select>
                              </div>
                            </div>
                            <div class="select-cards select-cls issue status-cls">
                              <div class="select-cls issue">
                                <div class="icon-clas q-filtr"></div>
                                <select
                                  @change="changeStatus(issue)"
                                  :name="'status' + issue"
                                  v-model="issue.status"
                                >
                                  <option
                                    v-for="statusItem in filterData.status"
                                    :key="statusItem"
                                    :value="statusItem"
                                  >{{statusItem}}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="col s3 m3 l3 p-0">
                            <div class="assignee-block col l8 pl-0">
                              <div class="assignee-title">Assignee</div>
                              <div class="assignee" v-if="issue.assigned_to_user">
                                <b>{{issue.assigned_to_user ? issue.assigned_to_user.first_name : ""}}</b>
                              </div>
                              <div class="assignee" v-if="!issue.assigned_to_user">
                                No one -
                                <a
                                  @click="assignMySelf(issue)"
                                  class="pointer"
                                >assign yourself</a>
                              </div>
                              <!-- <i
                                @click="openAssignees($event,issue)"
                                class="material-icons a-settings"
                              >settings</i>-->
                            </div>
                            <div class="assignee-settings col l4">
                              <popper
                                trigger="click"
                                :options="{placement: 'bottom'}"
                                :ref="`popper-${index}`"
                              >
                                <div class="assignees-list popper">
                                  <div class="input-search-box search-input">
                                    <div class="search-area">
                                      <i class="material-icons mr-2 search-icon">search</i>
                                      <input
                                        type="text"
                                        placeholder="Search assignees"
                                        id="assignee_filter"
                                        class="app-filter assignee_filter"
                                        v-model.trim="assigneeSearch"
                                        @keydown.enter="searchAssignee"
                                      />
                                    </div>
                                  </div>
                                  <div class="list-opts">
                                    <div
                                      class="assignees-list-items"
                                      @click="selectAssignee(assignee,index)"
                                      v-show="!(index==0 && currTab==1)"
                                      v-for="(assignee,vIndex) in assigneeList"
                                      :key="vIndex"
                                    >
                                      <div class="usr-img">{{assignee.short_name}}</div>
                                      <div class="uname">{{assignee.first_name}}</div>
                                      <div class="fullname">{{assignee.mobile_number}}</div>
                                    </div>
                                    <div v-if="assigneeList.length==0" class="assignees-list-items">
                                      <div
                                        class="uname center-align"
                                        style="width:100%"
                                      >No subadmins found</div>
                                    </div>
                                  </div>
                                </div>
                                <a slot="reference" class="top">
                                  <i
                                    @click="openAssignees($event,issue)"
                                    class="material-icons a-settings"
                                    :class="[`setting-${index}`]"
                                  >settings</i>
                                </a>
                              </popper>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";

export default {
  data() {
    return {
      currTab: 1,
      issueList: {
        results: [],
        count: 0,
        previous: null,
        next: null
      },
      finalIssueList: [],
      myIssueList: {
        results: [],
        count: 0,
        previous: null,
        next: null
      },
      assigneeList: [],
      assigneeAllList: [],
      currTicket: {},
      filterData: {
        classification: [],
        priority: [],
        status: []
      },
      filters: {
        search: "",
        priority: "",
        status: "",
        classification: ""
      },
      isLoader: true,
      isAdmin: false,
      assigneeSearch: ""
    };
  },
  components: {
    popper: Popper
  },
  async created() {
    let userDetails = JSON.parse(localStorage.homecare_admin_auth);
    this.isAdmin = userDetails.persona == "superuser";
    var thisObj = this;
    setTimeout(() => {
      Vue.scrollBottom("", async () => {
        if (thisObj.issueList.next && thisObj.currTab == 2) {
          await thisObj.listIssues(thisObj.issueList.next, true);
          thisObj.changeTab(thisObj.currTab);
        }
      });
      if (this.isAdmin) {
        let opts = {
          swipeable: true
        };
        window.tabInstance = M.Tabs.init($(".tabs"), {});
        $(".tab").on("click", async e => {
          if ($(".tab a.active").text() == "Issues") {
            thisObj.currTab = 1;
          } else {
            thisObj.currTab = 2;
          }
          await thisObj.searchFilter(thisObj.filters);
          thisObj.changeTab(thisObj.currTab);
        });
      }
      $("html")
        .off("click")
        .on("click", function(e) {
          if (
            !$(e.target).hasClass("a-settings") &&
            !$(e.target).hasClass("assignee_filter")
          ) {
            $(".assignees-list").removeClass("show-assignee");
          }
        });
    }, 500);
    if (this.isAdmin) {
      setTimeout(() => {
        window.tabInstance[0].updateTabIndicator();
      }, 1000);
    }

    setTimeout(() => {
      try {
        notificationHub.$on("received", payload => {
          console.log(payload);
          thisObj.onInitFunc();
        });
      } catch (error) {}
    }, 100);

    this.onInitFunc();
  },
  methods: {
    async onInitFunc() {
      let userDetails = JSON.parse(localStorage.homecare_admin_auth);
      this.isAdmin = userDetails.persona == "superuser";
      this.listAssignees();
      let [issueFlg, filterFlg] = await Promise.all([
        this.listIssues(),
        this.listFilterData()
      ]);
      let url =
        Constants.default.APIURL.IssueTickets +
        "?assigned_to_user=" +
        userDetails.id;
      if (this.isAdmin) {
        await this.listMyIssues(url);
        this.changeTab(1);
      } else {
        this.currTab = 2;
        this.changeTab(2);
      }
      setTimeout(() => {
        $(".filter-cls select").formSelect();
      }, 100);
    },
    listIssues(
      url = Constants.default.APIURL.ListIssueTickets,
      status = false
    ) {
      return new Promise(resolve => {
        ajax.get(
          url,
          res => {
            let temp = this.issueList;

            if (status) {
              let temp = this.issueList.results;
              this.issueList = {
                count: res.data.count,
                previous: res.data.previous,
                next: res.data.next
              };
              this.issueList.results = temp.concat(res.data.results);
            } else {
              this.issueList = res.data;
            }

            setTimeout(() => {
              this.isLoader = false;
            }, 500);
            resolve(true);
          },
          err => {
            this.isLoader = false;
            resolve(false);
          }
        );
      });
    },
    listMyIssues(url) {
      return new Promise(resolve => {
        ajax.get(
          url,
          res => {
            let temp = this.myIssueList;

            if (status) {
              let temp = this.myIssueList.results;
              this.myIssueList = {
                count: res.data.count,
                previous: res.data.previous,
                next: res.data.next
              };
              this.myIssueList.results = temp.concat(res.data.results);
            } else {
              this.myIssueList = res.data;
            }
            setTimeout(() => {
              this.isLoader = false;
            }, 500);
            resolve(true);
          },
          err => {
            this.isLoader = false;
            resolve(false);
          }
        );
      });
    },
    changeTab(tab) {
      if (tab == 1) {
        this.finalIssueList = this.myIssueList.results;
      } else {
        this.finalIssueList = this.issueList.results;
      }
      setTimeout(() => {
        $(".select-cls select").formSelect();
        if (this.finalIssueList.length == 0) {
          Vue.showNoDataBlock(".issue-block");
        } else {
          Vue.hideNoDataBlock(".issue-block");
        }
      }, 500);
    },
    listFilterData(url = Constants.default.APIURL.FilterTickets) {
      return new Promise(resolve => {
        ajax.get(
          url,
          res => {
            this.filterData = res.data;
            resolve(true);
          },
          err => {
            resolve(false);
          }
        );
      });
    },
    changePriority(issue) {
      let query = {
        issue_priority: issue.issue_priority
      };
      this.updateTicketStatus(query, issue);
    },
    changeClassification(issue) {
      let query = {
        classification: issue.classification
      };
      this.updateTicketStatus(query, issue);
    },
    changeStatus(issue) {
      let query = {
        status: issue.status
      };
      this.updateTicketStatus(query, issue);
    },
    updateTicketStatus(query, issue) {
      ajax.patch(
        (Constants.default.APIURL.IssueTickets + issue.issue_no + "/").replace(
          "#",
          ""
        ),
        query,
        res => {
          Vue.toast("Ticket has been updated successfully.");
        },
        err => {
          Vue.toast("", err);
        }
      );
    },
    async searchFilter(filter) {
      let userDetails = JSON.parse(localStorage.homecare_admin_auth);
      return new Promise(async resolve => {
        let queryStr = "?q=" + (filter.search || "");
        queryStr += "&issue_priority=" + (filter.priority || "");
        queryStr += "&classification=" + (filter.classification || "");
        queryStr += "&status=" + (filter.status || "");
        if (this.currTab == 1) {
          queryStr += "&assigned_to_user=" + userDetails.id;
          let url = Constants.default.APIURL.IssueTickets + queryStr;
          await this.listMyIssues(url);
          this.changeTab(this.currTab);
          resolve();
        } else {
          let url = Constants.default.APIURL.IssueTickets + queryStr;
          await this.listIssues(url);
          this.changeTab(this.currTab);
          resolve();
        }
      });
    },
    openAssignees(ev, issue) {
      var top = $(ev.target).offset().top + 30;
      var left = $(ev.target).offset().left - 300;
      $(".assignees-list").addClass("show-assignee");
      $(".assignees-list").css("top", top + "px");
      $(".assignees-list").css("left", left + "px");
      this.currTicket = issue;
    },
    selectTicket(issue, ev) {
      if (!$(ev.target).hasClass("booking")) {
        this.$router.push({ path: "/app/issue-detail/" + issue.issue_no });
      }
    },
    listAssignees(url = Constants.default.APIURL.SubAdmin) {
      let userDetails = JSON.parse(localStorage.homecare_admin_auth);
      return new Promise(resolve => {
        ajax.get(
          url,
          res => {
            let assignees = [
              {
                id: userDetails.id,
                first_name: "Assign Myself",
                short_name: "ME"
              }
            ];
            this.assigneeAllList = assignees.concat(res.data);
            this.assigneeList = JSON.parse(
              JSON.stringify(this.assigneeAllList)
            );
            resolve(true);
          },
          err => {
            resolve(false);
          }
        );
      });
    },
    selectAssignee(assignee, i) {
      let userDetails = JSON.parse(localStorage.homecare_admin_auth);
      let query = {
        user: assignee.id
      };
      ajax.patch(
        Constants.default.APIURL.IssueTickets +
          this.currTicket.issue_no +
          "/assign/",
        query,
        async res => {
          this.$refs[`popper-${i}`][0].doClose();
          Vue.toast("Ticket has been assigned successfully.");
          let url =
            Constants.default.APIURL.IssueTickets +
            "?assigned_to_user=" +
            userDetails.id;
          // await Promise.all([this.searchFilter(this.filters),this.listMyIssues(url)]);
          await this.searchFilter(this.filters);
          this.changeTab(this.currTab);
        },
        err => {
          Vue.toast("", err);
        }
      );
    },
    assignMySelf(issue) {
      this.currTicket = issue;
      this.selectAssignee({
        id: JSON.parse(localStorage.homecare_admin_auth).id
      });
    },
    searchAssignee() {
      this.assigneeList = this.assigneeAllList.filter(
        a =>
          a.first_name
            .toLowerCase()
            .indexOf(this.assigneeSearch.toLowerCase()) != -1
      );
    }
  },
  watch: {
    filters: {
      handler: function() {
        this.searchFilter(this.filters);
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.assignee-block {
  position: relative;
  text-align: left;
  .assignee-title {
    font-weight: 500;
  }
  .assignee {
    color: #183247;
    font-size: 14px;
  }
  i {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
    font-size: 18px;
    perspective-origin: 1000px;
    cursor: pointer;
  }
}

.tabs {
  text-align: left;
  border: 0 !important;
  // border-bottom: 1px solid gainsboro !important;
  li {
    a {
      cursor: pointer;
      color: #183247 !important;
    }
    a.active {
      pointer-events: none;
    }
  }
  .indicator {
    background-color: rgba(24, 50, 71, 0.8);
  }
}
.assignee-settings {
  position: relative;
  top: 10px;
  a {
    color: #183247;
    i {
      cursor: pointer;
      font-size: 18px;
    }
  }
}

.assignees-list {
  min-width: 350px;
  // overflow: hidden auto;
  padding: 5px;
  box-shadow: rgb(58, 58, 58) 0 0 1px 0;
  .input-search-box {
    padding: 10px;
    position: sticky;
    top: 0;
    background: white;
  }
  .assignees-list-items {
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: flex-start;
    padding: 5px 10px 0px 10px;
    min-height: 70px;
    div {
      margin: 5px;
      padding: 0px;
    }
    .usr-img {
      width: 30px;
      height: 30px;
      border-radius: 5px;
      background: #efe7e7;
    }

    .uname {
      font-weight: 600;
    }
  }
}

.show-assignee {
  max-height: 300px;
  opacity: 1;
}

.title-cd {
  font-weight: 600;
}

.created_at {
  color: #9e9e9e;
}

.owner {
  font-weight: 500;
  padding-right: 6px;
}
.name-cls {
  display: inline-block;
  white-space: nowrap;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.desp {
  padding: 0 10px;
}

.filter-cls {
  .input-field {
    margin-top: 10px;
  }
}

.search-input {
  .sidebar-search {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    padding: 1rem 0;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .search-area {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    width: -webkit-calc(100% - 0rem);
    width: -moz-calc(100% - 0rem);
    width: calc(100% - 0rem);
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  i {
    font-size: 1.45rem;
    height: 41px;
    margin-right: 0 !important;
    padding: 0.75rem 0.25rem 0.35rem 0.75rem;
    color: #9e9e9e;
    border-radius: 5px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background-color: #eceff1;
  }
  .app-filter {
    height: 35px;
    margin-bottom: 0;
    padding: 0.2rem;
    color: #9e9e9e;
    border: none;
    border-radius: 5px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background-color: #eceff1;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    border-bottom: 0 !important;
    box-shadow: none !important;
  }
}

.card-view:hover .indicator {
  height: 100%;
  top: 0 !important;
  opacity: 1;
}

.card-view {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(220, 220, 220, 0.151);
  margin: 15px 0;
  padding: 20px;
  position: relative;
  border-radius: 3px;
  .indicator {
    position: absolute;
    height: 0;
    width: 2px;
    background: #ef0000;
    left: -1px;
    top: 50%;
    opacity: 0;
    border-radius: 5px;
    transition: 0.4s ease-in-out;
  }
  .card-view-content {
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .owner {
      display: inline-block;
      font-weight: 500;
      padding-right: 6px;
      font-size: 14px;
    }
    .created_at {
      display: inline-block;
      color: #9e9e9e;
      font-size: 13px;
      &::before {
        content: "";
        display: inline-block;
        width: 4px;
        height: 4px;
        background: #a2aab4;
        border-radius: 100%;
        margin-right: 7px;
      }
    }
    .text-content {
      line-height: 1.8;
      .label-status {
        display: inline-block;
        margin-bottom: 3px;
      }
      span.classtag {
        background: #cdefd0;
        border-radius: 5px;
        padding: 1px 10px;
        border: 1px solid #cdefd0;
        font-size: 13px;
        margin-right: 15px;
      }
      span.prioritytag {
        border: 1px solid gainsboro;
        padding: 1px 10px;
        border-radius: 5px;
        font-size: 13px;
      }
      span.statustag {
        border: 1px solid #71c2f1;
        padding: 1px 10px;
        border-radius: 5px;
        font-size: 13px;
        margin-left: 15px;
        background: #71c2f1;
        color: #261ba7;
        font-weight: 500;
      }
    }
  }
}

.icon-clas {
  height: 9px;
  width: 9px;
  position: absolute;
  left: -15px;
  top: 9px;
  background: #9e9e9e;
  border-radius: 2px;
}

.icon-clas.q-cls {
  background: #ef0000;
}

.icon-clas.q-filtr {
  background: rgb(71, 131, 201);
}

.select-cards.select-cls.issue {
  position: relative;
  margin-bottom: 5px;
}
i.close-icon {
  position: absolute;
  right: 10px;
  cursor: pointer;
  font-size: 18px;
  top: 15px;
}
div#issues {
  div.inner-block {
    min-height: 500px;
  }
}

.title-cd a.booking {
  z-index: 999999;
  padding: 10px;
  perspective: 1000px;
}
</style>

